import React from 'react';
import Icon from 'screens/shared/icon';
import { _t } from 'utils';
import Cards from 'screens/shared/cards-layout';
import CardBasic from 'screens/shared/card-basic';
import { STORAGE_TYPE } from 'constant';

export default ({ storages = [] }) => (
  <Cards
    title={_t('Storages')}
    type="storage"
    isAdd={false}
    isFilter={false}
  >
    {storages.map((storage) => {
      const { id = '', properties = {} } = storage;
      const {
        type, name, size,
      } = properties;
      return (
        <CardBasic
          key={id}
          icon={type === STORAGE_TYPE.SSD ? 'sd-card' : type === STORAGE_TYPE.DAS ? 'memory' : 'hdd'}
          iconText={type}
          title={name}
          details={(
            <div>
              <Icon name="memory" />
              <span style={{ marginLeft: 5 }}>{`${size} GB`}</span>
            </div>
          )}
        />
      );
    })}
  </Cards>
);
